export enum EVideoCallRoomStatus {
  UNKNOWN,
  PAYMENT,
  PENDING,
  PROCESSING,
  TERMINATED
}

export class VideoCallRoom {

  id: string;

  url: string;

  duration: number;

  status: EVideoCallRoomStatus;

  textStatus: string;

  token?: string;


  constructor(
    other?: Partial<VideoCallRoom>
  ) {

    this.id =
      other?.id || '';

    this.url =
      other?.url || '';

    this.duration =
      other?.duration || 0;

    this.status =
      other?.status ??
      EVideoCallRoomStatus.UNKNOWN;

    this.textStatus =
      other?.textStatus || '';

    this.token =
      other?.token || '';
  }


  public static fromResponse(
    res: any
  ): VideoCallRoom {

    return new VideoCallRoom({

      id: res.id,

      url: res.url,

      duration: res.duration,

      status: res.status,

      textStatus: res.textStatus,

      token: res.token

    });
  }
}